<div class="compare-bg">

  <div class="padT20" *ngIf="fromType == '0'">
    <p style="text-indent: 2em;">广东电商企业深度信用信息查询由新华信用提供。用户登录后可查询广东境内所有电商企业深度信用信息，可在线生成企业信用报告。深度查询和信用报告内容包括：工商基本信息、股权结构、分支机构、对外投资、历史沿革、知识产权、商标、关联图谱、董监高对外任职、经营状况、司法信息、企业舆情、招投标、招聘类信息等。</p>
  </div>
  <div class="padT20" *ngIf="fromType == '1'">
    <p style="text-indent: 2em;">广东物流企业深度信用信息查询由新华信用提供。用户登录后可查询广东境内所有物流企业深度信用信息，可在线生成企业信用报告。深度查询和信用报告内容包括：工商基本信息、股权结构、分支机构、对外投资、历史沿革、知识产权、商标、关联图谱、董监高对外任职、经营状况、司法信息、企业舆情、招投标、招聘类信息等。</p>
  </div>
  <div>
    <table>
      <tbody>
        <tr><td colspan="2" style="padding: 10px 2em 20px;">操作流程：</td></tr>
        <tr><td colspan="2" style="padding: 0 2em;">
          <img width="100%" src="../../../assets/images/gz/liuchengtu.png"></td></tr>
        <tr><td colspan="2" style="padding: 20px 2em 5px;">用户须知</td></tr>
        <tr>
          <td valign="top" style="padding:5px 0 0 2em;" width="2%">1.</td>
          <td style="padding: 5px 2em 0px 1em;">本平台提供的深度企业信用信息具有非商业性、非认证性，相关结论仅用于用户了解相关企业信用状况，用户须妥善保管相关信息和报告。在未经平台及信用服务机构的允许下，不得公开传播，不得用于任何对外信用资质证明。</td></tr>
        <tr>
          <td valign="top" style="padding:5px 0 0 2em;" width="2%">2.</td>
          <td style="padding: 5px 2em 0px 1em;">为保护企业信用信息，保证查询通道顺畅，本平台有权对用户查询信息和下载报告次数做必要的限制，严禁用户恶意高频次查询和批量下载报告。</td></tr>
        <tr>
          <td valign="top" style="padding:5px 0 0 2em;" width="2%">3.</td>
          <td style="padding: 5px 2em 0px 1em;">用户单日下载报告次数不超过3次，每年累计下载报告次数不超过20次。超过以上次数，请登录www.credit100.com付费购买。</td></tr>
        <tr>
          <td valign="top" width="2%" style="padding:5px 0 0 2em;">&nbsp;</td>
          <td style="padding: 5px 2em 0px 1em;">
            <div class="padT20 padB22">
              <label nz-checkbox [(ngModel)]="checkResult">
                <span style="font-weight: bold;">我已阅读并接受以上条款</span>
              </label>
            </div>
          </td></tr>
      </tbody>
    </table>
  </div>
  <div style="text-align: center;">
    <button  nz-button [nzType]="'primary'" [disabled]="!checkResult" (click)="closeAlert()">进入深度查询</button>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/protocol-msg/protocol-msg.component.html